import React from 'react';
import { Box, Container, Theme, Typography } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import classnames from 'classnames';
import getConfig from 'next/config';
import SearchBar from '../Search/SearchBar';
import TradeLocationSearch from '../Trades/TradeLocationSearch';
import { FilterUrlKey } from '../../helpers/filters';
import routes from '../../helpers/routes';
import { useStyles } from './OldHero.styles';
import { SeoListType } from '../../types/seo-list-type';

const { publicRuntimeConfig } = getConfig();

const routeResolver = async (
  location: string,
  key: string,
  filter?: FilterUrlKey
): Promise<string> => {
  switch (filter) {
    case FilterUrlKey.trade: {
      return routes.search(location, key);
    }
    case FilterUrlKey.companyType: {
      return routes.search(location, undefined, undefined, key);
    }
    case FilterUrlKey.constructionSector: {
      return routes.search(location, undefined, key);
    }
    default: {
      return routes.search(location, key);
    }
  }
};

interface OldHeroProps {
  searchBarOverrideItem?: SeoListType;
  filter?: FilterUrlKey;
  title?: string;
  subTitle?: string;
}

const OldHero = React.forwardRef(
  (
    {
      title = 'Find Everyone in Construction. Right Here.',
      subTitle = 'Procore helps you find and connect with construction pros so you can get the job done.',
      searchBarOverrideItem,
      filter,
    }: OldHeroProps,
    ref: React.Ref<HTMLDivElement>
  ) => {
    const classes = useStyles();
    const smView = useMediaQuery((theme: Theme) =>
      theme.breakpoints.down('sm')
    );

    return (
      <div className={classes.root} ref={ref}>
        <Container>
          <Box>
            <div>
              <Typography
                align="center"
                className={classnames(
                  classes.bannerText,
                  classes.bannerTextHeader
                )}
                variant="h1"
              >
                {title}
              </Typography>
              <Typography
                align="center"
                className={classnames(
                  classes.bannerText,
                  classes.bannerTextSubheader
                )}
                variant="h2"
              >
                {subTitle}
              </Typography>
            </div>
            <div className={classes.searchBarRow}>
              {!searchBarOverrideItem ? (
                <SearchBar hero smView={smView} routeResolver={routeResolver} />
              ) : (
                <TradeLocationSearch
                  item={searchBarOverrideItem}
                  filter={filter}
                  routeResolver={routeResolver}
                />
              )}
            </div>
          </Box>
        </Container>
        <video
          className={classes.backgroundVideo}
          poster={`${publicRuntimeConfig.assetsStaticBasePath}/background-video-loading.webp`}
          autoPlay
          playsInline
          loop
          muted
        >
          <source
            src={`${publicRuntimeConfig.assetsStaticBasePath}/background-video.webm`}
            type="video/webm"
          />
          <source
            src={`${publicRuntimeConfig.assetsStaticBasePath}/background-video.mp4`}
            type="video/mp4"
          />
        </video>
      </div>
    );
  }
);

OldHero.displayName = 'Hero';

export default OldHero;
